import * as Types from '../graphql.generated';

export type FetchUserQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FetchUserQuery = { __typename?: 'Query' } & {
    user?: Types.Maybe<
        { __typename?: 'User' } & Pick<
            Types.User,
            | 'loggedIn'
            | 'name'
            | 'email'
            | 'status'
            | 'senderPropertyStatus'
            | 'userId'
            | 'userUuid'
            | 'creationDate'
            | 'brandPrimary'
            | 'registrationSources'
            | 'registered'
        >
    >;
};

export const FetchUserDocument = `
    query fetchUser {
  user {
    loggedIn
    name
    email
    status
    senderPropertyStatus
    userId
    userUuid
    creationDate
    brandPrimary
    registrationSources
    registered
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        fetchUser(
            variables?: FetchUserQueryVariables,
            options?: C
        ): Promise<FetchUserQuery> {
            return requester<FetchUserQuery, FetchUserQueryVariables>(
                FetchUserDocument,
                variables,
                options
            );
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
